import { defineStore } from 'pinia';

import { LeadService } from '@/js/services/LeadForms/LeadFormService';

export const useLeadFormsStore = defineStore('leadFormsStore', {
  state() {
    return {
      showGetOfferForm: false,
      showRequestQuoteModal: false,
      showValueYourTradeModal: false,
      showContactFinanceDealerModal: false,
      showTestDriveModal: false,
      showScheduleServiceModal: false,
      showGetFinanceModal: false,
      showBonusOfferModal: false,
      showTextModal: false,
      leadFormSettings: null,
      formHeading: null,
      formButtonLabel: '',
      showContactServiceModal: false,
      showAccessoryModal: false,
      showPrecisionTradeValuePopup: false,
      showServiceAppraisalPopup: false,
      showPrecissionBonusOfferPopup: false,
      showCallUsButtonsModal: false,
      showTextPermissionOverlay: false,
      showContactGeneralAdminModal: false,
      showContactPartsModal: false,
      showContactUsModal: false,
      showGoogleAssistantModal: false,
      leadFormFormProps: {},
      showSchedulePickupModal: false,
      openOtpDetailsModal: false,
      otpModalData: {},
    };
  },

  actions: {
    async fetchLeadFormSettings() {
      const response = await LeadService.getLeadFormUrls();
      if (response?.data) {
        this.leadFormSettings = response.data;
      }
    },
    toggleCallButtonModal(open = true, props = {}) {
      if (open) {
        this.showCallUsButtonsModal = true;
        this.leadFormFormProps = props;
      } else {
        this.showCallUsButtonsModal = false;
        this.leadFormFormProps = {};
      }
    },
    toggleContactUsModal(open = true, props = {}) {
      if (open) {
        this.showContactUsModal = true;
        this.leadFormFormProps = props;
      } else {
        this.showContactUsModal = false;
        this.leadFormFormProps = {};
      }
    },
    toggleModal(modalName, open = true, props = {}) {
      this[modalName] = open;
      this.leadFormFormProps = open ? props : {};
    },
  },
});
